import Navbar from '../../@shared/navigations/default';
import { Options } from './options';
import {ProfileEdit} from './profileEdit'

const AccountPage = () => {
    return (
      <div id="account">
        <Navbar />
        <div className="container3">
           <div className="">
           <div> <ProfileEdit type="account-page" /> </div>
            <div className="sticky"><Options path='/account'  /> <br /></div>
           </div>
        </div>
      </div>
    )
}
  
export default AccountPage
  
